import * as React from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { 
    FormControl, 
    TextField,
    Box
} from "@mui/material";
import "./Login.css";
import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  FINANCIAL_YEARS,
} from "../../../RTK/Slices/AuthSlice";
import {
  get_financial_year,
  portalInfo,
  fetchDefaultUser,
  sendOtpToDefaultUser,
  verifyOtpAndAddDefaultUser,
  verifyAadhaarSmartauth,
  getAadhaarVerificationStatus
} from "../../../helper/Api";
import { toast } from "react-toastify";
import { isValidURL } from "../../../helper/Utils";
import ReCAPTCHA from "react-google-recaptcha";
import moment from "moment";
import Spinner from "../../../components/Tools/spinner";

const FirstUser = () => {
  const [transactionId, setTransactionId] = useState(null);
  const [adhaarNo, setAdhaarNo] = useState('');
  const { id } = useParams();
  const [formData, setformData] = useState({
    email: null,
    password: null,
    user_type: 'l3',
    mobile: null,
    email: null,
    code: null,
    user_name: null,
    designation: null,
    department_id: 1,
    confirm_password: null,
    user_id: id || null,
  });
  const [otpFormData, setOtpFormData] = useState({
    mobile_otp: null,
    email_otp: null,
  });
  const [isFormActive, setIsFormActive] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  const [send_otp, setSend_otp] = useState(false);
  const [captchaValue, setCaptchaValue] = useState("");
  const recaptchaRef = React.createRef();
  const [seconds, setSeconds] = useState(0);
  const [nextStep, setNextStop] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const domainName = window.location.hostname;
  const [departmentInfo, setDepartmentInfo] = useState({
    portal_logo: null,
    portal_title: null,
  });
  const [defaultUser, setDefaultUser] = useState(null);
  const [isPageBlocked, setIsPageBlocked] = useState(false);
  const [blockTimer, setBlockTimer] = useState(0);

  const getFinancialYear = async () => {
    try {
      const fy = await get_financial_year();
      if (fy.data.status) {
        let domainInfo;
        const res = await portalInfo({ domain: domainName });
        if (res.data.status) {
          domainInfo = res.data.result;
          if (res.data.result.portal_logo) {
            setDepartmentInfo({
              portal_logo: res.data.result.portal_logo,
              portal_title: res.data.result.portal_title,
            });
          } else {
            setDepartmentInfo({
              portal_logo: res.data.result.portal_logo_spare,
              portal_title: res.data.result.portal_title,
            });
          }
        }
        const userRes = await fetchDefaultUser(id);
        if (userRes.data.status) {
            if(userRes?.data?.result) {
              let result = userRes.data.result;
              setformData({
                  email: result.email,
                  user_type: result.user_type,
                  mobile: result.mobile,
                  code: result.code,
                  user_name: result.user_name,
                  designation: result.designation,
                  department_id: 1,
                  user_id: result.id,
              });
              setDefaultUser(result);
            }
        }
        const monthName = moment().format("MMM");
        let fy_id;
        if (monthName == "Jan" || monthName == "Feb" || monthName == "Mar") {
          fy_id = fy.data.list.find(
            (e) => e.end_year === moment().format("YYYY")
          );
        } else {
          fy_id = fy.data.list.find(
            (e) => e.start_year === moment().format("YYYY")
          );
        }
        let obj = {
          payload: {
            fy_list: fy.data.list,
            fy_id: fy_id.id,
            domainInfo,
          },
        };
        dispatch(FINANCIAL_YEARS(obj));
        localStorage.setItem("globalDateId", fy_id.id);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Error fetching financial year", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const sendOtpToDefaultUserFunc = async () => {
    setLoading(true);
    if(!formData.mobile) {
        toast.error("Mobile number is required to send OTP", {
            position: toast.POSITION.TOP_CENTER,
        });
        return;
    }
    if(!formData.email) {
        toast.error("Email is required to send OTP", {
            position: toast.POSITION.TOP_CENTER,
        });
        return;
    }
    const postData = {
        mobile: formData.mobile,
        email: formData.email,
        domain: domainName
    };
    const response =  await sendOtpToDefaultUser(postData);
    if(response.data.status) {
        console.log('formData', formData);
        setLoading(false);
        toast.success("OTP sent successfully", {
            position: toast.POSITION.TOP_CENTER,
        });
        setSend_otp(true);
    } else {
        setLoading(false);
        toast.error(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
        });
    }
  };

  useEffect(() => {
    if (seconds > 0) {
      const timer = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [seconds]);

  // Countdown timer for page blocking
  useEffect(() => {
    if (blockTimer > 0) {
      const timer = setInterval(() => {
        setBlockTimer((prev) => {
          if (prev <= 1) {
            setIsPageBlocked(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [blockTimer]);

  // Polling API for Aadhaar verification status
  useEffect(() => {
    let pollingInterval = null;
    
    const checkAadhaarStatus = async () => {
      try {
        if (!transactionId) return;
        const response = await getAadhaarVerificationStatus(transactionId);
        if (response.data.status && response.data.data) {
          const verificationStatus = Number(response.data.data);
          const message = response.data.message;
          
          // Status 2 = Processing, continue polling
          if (verificationStatus === 2) {
            return;
          }
          
          // Status 1 = Success: backend has verified the Aadhaar
          if (verificationStatus === 1) {
            // Stop polling
            if (pollingInterval) {
              clearInterval(pollingInterval);
            }
            // Unblock page and reset state
            setIsPageBlocked(false);
            setBlockTimer(0);
            setTransactionId(null);

            toast.success(message || 'Aadhaar verified successfully!', {
              position: toast.POSITION.TOP_CENTER,
            });

            // Redirect to login page
            navigate('/login');
            return;
          }

          // Status 0 or other = Failed
          if (verificationStatus === 0) {
            console.log('Aadhaar verification failed:', message);

            if (pollingInterval) {
              clearInterval(pollingInterval);
            }
            setIsPageBlocked(false);
            setBlockTimer(0);
            setTransactionId(null);

            toast.error(message || 'Aadhaar verification failed', {
              position: toast.POSITION.TOP_CENTER,
            });
            return;
          }
        }
      } catch (error) {
        toast.error('Error checking Aadhaar verification status. Please try again later.', {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    };
    
    // Start polling when page is blocked and transactionId is available
    if (isPageBlocked && transactionId) {
      // Check immediately
      checkAadhaarStatus();
      
      // Then check every 30 seconds
      pollingInterval = setInterval(() => {
        checkAadhaarStatus();
      }, 10000); // 10 seconds
    }
    
    // Cleanup on unmount or when polling stops
    return () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };
  }, [isPageBlocked, transactionId, id]);

  // Stop polling when timer ends
  useEffect(() => {
    if (blockTimer === 0 && isPageBlocked) {
      setTransactionId(null);
      toast.warning("Verification time expired. Please try again.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }, [blockTimer, isPageBlocked]);

  useEffect(() => {
    getFinancialYear();
  }, []);

  const validateFormData = (formData) => {
    // Email validation
    if (!formData.email || formData.email.trim() === "") {
      toast.error("Email is required to send OTP", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    // Mobile validation
    if (!formData.mobile || formData.mobile.trim() === "") {
      toast.error("Mobile number is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(formData.mobile)) {
      toast.error("Mobile number must be 10 digits", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    // Username validation
    if (!formData.user_name || formData.user_name.trim() === "") {
      toast.error("User name is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    // Designation validation
    if (!formData.designation || formData.designation.trim() === "") {
      toast.error("Designation is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    // Department validation
    if (!formData.department_id) {
      toast.error("Department is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    // Password validation (Presence)
    if (!formData.password || formData.password.trim() === "") {
      toast.error("Password is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    // Password format validation (Your regex)
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (!passwordRegex.test(formData.password)) {
      toast.error("Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character.", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    // Confirm password validation
    if (!formData.confirm_password || formData.confirm_password.trim() === "") {
      toast.error("Please confirm your password", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    if (formData.password !== formData.confirm_password) {
      toast.error("Passwords do not match", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    if (!formData.code || formData.code.trim() === "") {
      toast.error("Employee code is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    setDisabled(true);
    e.preventDefault();
    if(!captchaValue) {
        toast.error("Please complete the CAPTCHA", {
            position: toast.POSITION.TOP_CENTER,
        });
        setDisabled(false);
        return;
    }
    if(!defaultUser) {
      if (!validateFormData(formData)) {
        return;
      }
    }
    await sendOtpToDefaultUserFunc();
    setDisabled(false);
  };
  const mainHeading = "SNA - Financial Management System";
  const handleFormData = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setformData({ ...formData, [name]: value });
  };
  const handleOtpFormData = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setOtpFormData({ ...otpFormData, [name]: value });
  }

  const verfiyAndCreateFirstUser = async (e) => {
    try {
        setLoading(true);
        e.preventDefault();
        if(!otpFormData.mobile_otp || otpFormData.mobile_otp.trim() === '') {
            toast.error("Mobile OTP is required", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if(!otpFormData.email_otp || otpFormData.email_otp.trim() === '') {
            toast.error("Email OTP is required", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        const postData = {
            ...formData,
            ...otpFormData,
            domain: domainName
        };
        const response =  await verifyOtpAndAddDefaultUser(postData);
        if(response.data.status) {
            setLoading(false);
            toast.success(response.data.message, {
                position: toast.POSITION.TOP_CENTER,
            });
            navigate("/login");
        } else {
            setLoading(false);
            toast.error(response.data.message, {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    }catch (error) {
        setLoading(false);
        toast.error("Error verifying OTP and creating user", {
            position: toast.POSITION.TOP_CENTER,
        });
    }
    
  }

  const verifyAdhaarHandler = async (e) => {
    try {
        e.preventDefault();
        if(!adhaarNo || adhaarNo.trim() === '') {
            toast.error("Adhaar number is required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }
        
        setLoading(true);
        
        let body = {
            aadhaar_number: adhaarNo,
            name: defaultUser.user_name,
            first_name: defaultUser.user_name,
            user_id: defaultUser.id,
        }
        
        const res = await verifyAadhaarSmartauth(body);
        
        if(res.data.status) {
            if(res.data.data.result && res.data.data.result.url) {
                const url = res.data.data.result.url;
                // Validate the URL to prevent open redirect to unsafe locations
                if (!isValidURL(url) || !/^https:\/\//i.test(url)) {
                    setLoading(false);
                    toast.error("Invalid verification URL", { position: toast.POSITION.TOP_CENTER });
                } else {
                    // Open URL in new tab after a short delay to show loader
                    toast.info("Redirecting to Aadhaar verification page...", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                    setTimeout(() => {
                        setTransactionId(res.data.data.txn_id);
                        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
                        if (newWindow) {
                            try { newWindow.opener = null; } catch (e) { /* ignore */ }
                        }
                        setLoading(false);
                        setIsPageBlocked(true);
                        setBlockTimer(300); // 5 minutes = 300 seconds
                        toast.success("Please complete verification in the new tab", {
                            position: toast.POSITION.TOP_CENTER,
                        });
                    }, 2000);
                }
            } else {
                setLoading(false);
                toast.success("Adhaar verified successfully", {
                    position: toast.POSITION.TOP_CENTER,
                });
                navigate("/login");
            }
        } else {
            setLoading(false);
            toast.error(res.data.message, {
                position: toast.POSITION.TOP_CENTER,
            });
        }
    } catch(error) {
        console.log('error in adhaar verification', error);
        setLoading(false);
        toast.error(error.response?.data?.message || "Error verifying Adhaar card", {
            position: toast.POSITION.TOP_CENTER,
        });
    }
  }

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Determine dynamic button text for starting/continuing first user creation
  const startButtonText = (() => {
    if (!defaultUser) return "Let's Start First User creation";
    const pending = [];
    if (defaultUser.is_email_verified === "0") pending.push('Email');
    if (defaultUser.is_mobile_verified === "0") pending.push('Mobile');
    if (defaultUser.is_adhaar_verified === "0") pending.push('Aadhaar');
    if (pending.length === 0) return 'Proceed to create user';
    return `Verify ${pending.join(' & ')}`;
  })();

  return (
    <>
      {loading && (
        <div>
          <Spinner />
        </div>
      )}
      
      {/* Blocking Overlay */}
      {isPageBlocked && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
          }}
        >
          <div
            style={{
              backgroundColor: '#28326f',
              padding: '40px',
              borderRadius: '15px',
              textAlign: 'center',
              maxWidth: '500px',
              boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
            }}
          >
            <h2 style={{ marginBottom: '20px', fontSize: '28px', color: '#2490EA' }}>
              Aadhaar Verification in Progress
            </h2>
            <p style={{ fontSize: '18px', marginBottom: '30px', lineHeight: '1.6' }}>
              Please complete the verification in the new tab.
              <br />
              <strong style={{ color: '#ff6b6b' }}>Do not refresh this page!</strong>
            </p>
            <div
              style={{
                fontSize: '48px',
                fontWeight: 'bold',
                color: '#2490EA',
                marginBottom: '15px',
                fontFamily: 'monospace',
              }}
            >
              {formatTime(blockTimer)}
            </div>
            <p style={{ fontSize: '14px', color: '#aaa' }}>
              This page will automatically unlock after verification or in {formatTime(blockTimer)} minutes
            </p>
          </div>
        </div>
      )}

      <Grid
        container
        component="div"
        className="position-relative overflow-x-hidden"
        sx={{ height: "100vh" }}
      >
        <div
          className=" position-relative w-100 mobile-hide"
          style={{ height: "20%" }}
        >
          <div
            className="position-absolute d-flex justify-content-center align-items-center"
            style={{
              width: "160px",
              height: "160px",
              zIndex: "3",
              left: "6%",
              borderRadius: "0 0 80px 80px",
              backgroundColor: "#ffffff",
            }}
          >
            <div
              className="p-3 rounded-circle overflow-hidden"
              style={{ objectFit: "cover", objectPosition: "center" }}
            >
              <img
                src={departmentInfo.portal_logo}
                alt="logo"
                className="cursor-pointer"
                width="100%"
                onClick={() => setNextStop(1)}
              />
            </div>
          </div>

          <div
            className="position-absolute w-100"
            style={{ top: "-8%", zIndex: "2" }}
          >
            <div className="position-relative">
              <img
                src="/loginpage/darkBlueBg.svg"
                alt="svg"
                className="h-100 cursor-pointer"
              />

              <h2
                className="position-absolute text-white end-0 w-75 fw-600 text-end"
                style={{
                  top: "12%",
                  fontSize: "34px",
                  textWrap: "nowrap",
                  paddingRight: "7.2rem",
                }}
              >
                {mainHeading}
              </h2>
              <div
                className="bg-secondary-100 position-absolute end-0 w-100 top-0"
                style={{ height: "40.7%", zIndex: "-1" }}
              ></div>
            </div>
          </div>

          <div
            className="position-absolute w-100"
            style={{ top: "48%", zIndex: "1" }}
          >
            <div className="position-relative">
              <img src="/loginpage/skyBlueBg.svg" alt="svg" className="h-100" />
              <p
                className="position-absolute text-white end-0 text-end w-75"
                style={{ top: "6%", fontSize: "18px", paddingRight: "7.2rem" }}
              >
                {departmentInfo.portal_title}
              </p>
              <div
                className="bg-prime-100 position-absolute end-0 w-100"
                style={{ height: "82%", zIndex: "-1", top: "-50%" }}
              ></div>
            </div>
          </div>
        </div>

        <div className="d-lg-none w-100 mb-4 ">
          <div className="bg-secondary-100 text-white pb-3 d-flex align-items-center flex-column ">
            <div
              className="d-flex justify-content-center align-items-center bg-white p-3 rounded-circle overflow-hidden "
              style={{
                width: "160px",
                height: "160px",
                zIndex: "3",
                left: "6%",
                borderRadius: "0 0 80px 80px",
                objectFit: "cover",
                objectPosition: "center",
              }}
            >
              <img
                src={departmentInfo.portal_logo}
                alt="logo"
                width="100%"
                style={{ scale: "1.2" }}
                className="cursor-pointer"
                onClick={() => setNextStop(1)}
              />
            </div>
            <span className="d-inline-block fs-24px text-center mt-1 w-100 px-3">
              {mainHeading}
            </span>
          </div>
          <div className="bg-prime-100 py-3">
            <span className="d-inline-block fs-18px text-white text-center w-100 px-3">
              {departmentInfo.portal_title}
            </span>
          </div>
        </div>

        <Grid item xs={12} sm={12} md={12} component="div" className="d-flex">
          {/* =====================images====================== */}
          <div
            component="main"
            className="w-100 mt-lg-4"
            style={{ zIndex: "4" }}
          >
            {/* ============================form================================= */}
            <div className="container">
              {!isFormActive && <div
                className="row justify-content-between align-items-center"
                style={{ scale: "0.9" }}
              >
                <div className="h-100 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end">
                  <Box sx={{ mt: 1, scale: "1" }} className="form_box p-4">
                    <h2 className="fs-24px fw-500 text-center my-3">Welcome</h2>
                    <p>
                      To ensure the security of your account and provide you with a safe experience, we require verification of your mobile number, email address, and Aadhaar details. This verification helps us confirm your identity and enables seamless access to all platform features. Please complete the verification process to continue.
                    </p>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      disabled={isDisabled}
                      onClick={() => setIsFormActive(true)}
                      sx={{
                        mt: 3,
                        mb: 2,
                        background: "#2490EA",
                        padding: " 0.7rem 0.3rem",
                      }}
                    >
                      {startButtonText}
                    </Button>
                  </Box>
                </div>

                <div
                  className="col-md-12 col-lg-6 h-100 position-relative"
                  style={{ scale: "0.8" }}
                >
                  <img src="/loginpage/mandir.svg" alt="" className="w-100" />
                  <img
                    src="/loginpage/family.svg"
                    alt="vector"
                    className="position-absolute w-100"
                    style={{
                      top: "50%",
                      left: "45%",
                      translate: "-40% -45%",
                      scale: "0.6",
                    }}
                  />
                </div>
              </div>}

              {isFormActive && <div className="row justify-content-between align-items-center" style={{ scale: "0.9" }}>
                {(!send_otp && !defaultUser) && <>
                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="employee_code"
                            label="Employee Code" 
                            variant="outlined" 
                            type="text"
                            name="code"
                            value={formData.code || (defaultUser && defaultUser.code) || ''}
                            onChange={handleFormData}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="user_name"
                            label="Username" 
                            variant="outlined" 
                            type="text"
                            name="user_name"
                            value={formData.user_name || (defaultUser && defaultUser.user_name) || ''}
                            onChange={handleFormData}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="designation"
                            label="Designation" 
                            variant="outlined" 
                            type="text"
                            name="designation"
                            value={formData.designation || (defaultUser && defaultUser.designation) || ''}
                            onChange={handleFormData}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="mobile"
                            label="Mobile Number" 
                            variant="outlined" 
                            type="text"
                            name="mobile"
                            value={formData.mobile || (defaultUser && defaultUser.mobile) || ''}
                            onChange={handleFormData}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="email"
                            label="Email Id" 
                            variant="outlined" 
                            type="email"
                            name="email"
                            value={formData.email || (defaultUser && defaultUser.email) || ''}
                            onChange={handleFormData}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="department_name"
                            label="Department Level" 
                            variant="outlined" 
                            type="text"
                            value={"T1"}
                            InputLabelProps={{ shrink: true }}
                            disabled={true}
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="user_type"
                            label="User Type" 
                            variant="outlined" 
                            type="text"
                            value={"L3"}
                            InputLabelProps={{ shrink: true }}
                            disabled={true}
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="password"
                            label="Password" 
                            variant="outlined" 
                            type="password"
                            name="password"
                            value={formData.password || ''}
                            onChange={handleFormData}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="confirm_password"
                            label="Confirm Password" 
                            variant="outlined" 
                            type="password"
                            name="confirm_password"
                            value={formData.confirm_password || ''}
                            onChange={handleFormData}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-12 mb-3">
                        <ReCAPTCHA
                            sitekey="6Lei810pAAAAAL-HaSHvdad5f5VBl-aiil_YTJUS"
                            ref={recaptchaRef}
                            onChange={(value) => setCaptchaValue(value)}
                          />
                    </div>
                    <div className="col-lg-12 mb-3">
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            onClick={(e) => handleSubmit(e)}
                            sx={{
                                mt: 3,
                                mb: 2,
                                background: "#2490EA",
                                padding: " 0.7rem 0.3rem",
                            }}
                            >Submit</Button>
                    </div>
                </>}
                {/* if user already saved in db */}

                {(!send_otp && (defaultUser.is_email_verified === "0" || defaultUser.is_mobile_verified === "0")) && <>
                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="employee_code"
                            label="Employee Code" 
                            variant="outlined" 
                            type="text"
                            name="code"
                            value={formData.code || (defaultUser && defaultUser.code) || ''}
                            onChange={handleFormData}
                            disabled={true}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="user_name"
                            label="Username" 
                            variant="outlined" 
                            type="text"
                            name="user_name"
                            value={formData.user_name || (defaultUser && defaultUser.user_name) || ''}
                            onChange={handleFormData}
                            disabled={true}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="designation"
                            label="Designation" 
                            variant="outlined" 
                            type="text"
                            name="designation"
                            value={formData.designation || (defaultUser && defaultUser.designation) || ''}
                            onChange={handleFormData}
                            disabled={true}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="mobile"
                            label="Mobile Number" 
                            variant="outlined" 
                            type="text"
                            name="mobile"
                            value={formData.mobile || (defaultUser && defaultUser.mobile) || ''}
                            onChange={handleFormData}
                            disabled={true}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="email"
                            label="Email Id" 
                            variant="outlined" 
                            type="email"
                            name="email"
                            value={formData.email || (defaultUser && defaultUser.email) || ''}
                            onChange={handleFormData}
                            disabled={true}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="department_name"
                            label="Department Level" 
                            variant="outlined" 
                            type="text"
                            value={"T1"}
                            InputLabelProps={{ shrink: true }}
                            disabled={true}
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <FormControl fullWidth>
                            <TextField 
                            id="user_type"
                            label="User Type" 
                            variant="outlined" 
                            type="text"
                            value={"L3"}
                            InputLabelProps={{ shrink: true }}
                            disabled={true}
                            />
                        </FormControl>
                    </div>

                    <div className="col-lg-12 mb-3">
                        <ReCAPTCHA
                            sitekey="6Lei810pAAAAAL-HaSHvdad5f5VBl-aiil_YTJUS"
                            ref={recaptchaRef}
                            onChange={(value) => setCaptchaValue(value)}
                          />
                    </div>
                    <div className="col-lg-12 mb-3">
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            onClick={(e) => handleSubmit(e)}
                            sx={{
                                mt: 3,
                                mb: 2,
                                background: "#2490EA",
                                padding: " 0.7rem 0.3rem",
                            }}
                            >Submit</Button>
                    </div>
                </>}
                {/* if otp sent */}
                { send_otp && <div className="row">
                        <div className="col-lg-6 offset-lg-3 mb-3" style={{
                            border: "4px solid #28326f", borderRadius: "10px", padding: "20px" }}>
                            <div className="row">
                                <div className="col-lg-12 mb-3">
                                    <FormControl fullWidth>
                                        <TextField 
                                        id="mobile_otp"
                                        label="Mobile OTP" 
                                        variant="outlined" 
                                        type="text"
                                        name="mobile_otp"
                                        value={otpFormData.mobile_otp || ''}
                                        onChange={handleOtpFormData}
                                        required
                                        />
                                    </FormControl>
                                </div>

                                <div className="col-lg-12 mb-3">
                                    <FormControl fullWidth>
                                        <TextField 
                                        id="email_otp"
                                        label="Email OTP" 
                                        variant="outlined" 
                                        type="text"
                                        name="email_otp"
                                        value={otpFormData.email_otp || ''}
                                        onChange={handleOtpFormData}
                                        required
                                        />
                                    </FormControl>
                                </div>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    onClick={(e) => verfiyAndCreateFirstUser(e)}
                                    disabled={isDisabled}
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        background: "#2490EA",
                                        padding: " 0.7rem 0.3rem",
                                    }}
                                    >Verify Otp & Submit</Button>
                            </div>
                        </div>
                        
                    </div>
                }
                {/* if adhaar not verified */}
                {
                    (defaultUser && defaultUser?.is_email_verified === "1" && defaultUser?.is_mobile_verified === "1" && defaultUser?.is_adhaar_verified === "0") && <div className="row" style={{
                            border: "4px solid #28326f", borderRadius: "10px", padding: "20px" }}>
                    <div className="col-lg-4">
                        <p style={{margin: "0px",color: "#2590ea"}}>User Name</p>
                        <h4 style={{color: "#28326f"}}>{defaultUser.user_name}</h4>
                    </div>
                    <div className="col-lg-4">
                        <p style={{margin: "0px",color: "#2590ea"}}>Employee Code</p>
                        <h4 style={{color: "#28326f"}}>{defaultUser.code}</h4>
                    </div>
                    <div className="col-lg-4">
                        <p style={{margin: "0px",color: "#2590ea"}}>Designation</p>
                        <h4 style={{color: "#28326f"}}>{defaultUser.designation}</h4>
                    </div>
                    <div className="col-lg-4">
                        <p style={{margin: "0px",color: "#2590ea"}}>Mobile No.</p>
                        <h4 style={{color: "#28326f"}}>{defaultUser.mobile}</h4>
                    </div>
                    <div className="col-lg-4">
                        <p style={{margin: "0px",color: "#2590ea"}}>Email</p>
                        <h4 style={{color: "#28326f"}}>{defaultUser.email}</h4>
                    </div>
                    <div className="col-lg-4">
                        <p style={{margin: "0px",color: "#2590ea"}}>Department Level</p>
                        <h4 style={{color: "#28326f"}}>T1</h4>
                    </div>
                    <div className="col-lg-4">
                        <p style={{margin: "0px",color: "#2590ea"}}>User Type</p>
                        <h4 style={{color: "#28326f"}}>L3</h4>
                    </div>
                    <div className="col-lg-12">
                        <hr />
                    </div>
                    <div className="col-lg-8">
                        <FormControl fullWidth>
                            <TextField 
                            id="adhaar"
                            label="Enter Adhaar Number" 
                            variant="outlined" 
                            type="number"
                            name="adhaar"
                            value={adhaarNo || ''}
                            onChange={(e) => setAdhaarNo(e.target.value)}
                            required
                            />
                        </FormControl>
                    </div>
                    <div className="col-lg-4">
                        <button 
                        type="button" 
                        className="submit_button w-100"
                        onClick={(e) => verifyAdhaarHandler(e)}
                        >Verify Adhaar Card</button>
                        <p style={{fontSize: "12px"}}>* By clicking the Verify button, you are giving your consent to use your Aadhaar details for verification purposes.</p>
                    </div>
                </div>
                }
                



              </div>}
            </div>
          </div>
        </Grid>
        <div
          className="w-100 d-flex flex-column justify-content-end"
          style={{ bottom: "0" }}
        >
          <p className="m-0 d-flex justify-content-end pe-5 pb-2">
            Powered by Tangy Media | India
          </p>
          <div className=" bg-prime-100 w-100" style={{ height: "5px" }}></div>
          <div
            className=" bg-secondary-100 w-100"
            style={{ height: "5px" }}
          ></div>
        </div>
      </Grid>
    </>
  );
};

export default FirstUser;
